/* overlays/NotSupportedOverlay.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	attr,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "svelte/internal";

function create_fragment(ctx) {
	let main;

	return {
		c() {
			main = element("main");

			main.innerHTML = `<div class="svelte-1wrnee7"><p>Your browser does not support WebGL, or it has been disabled.</p> 

    <p>Try viewing this experience in latest Chrome, Safari or FireFox. You may
      need to go into the browser settings and enable WebGL and hardware
      acceleration in order to play.</p></div>`;

			attr(main, "class", "svelte-1wrnee7");
		},
		m(target, anchor) {
			insert(target, main, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(main);
		}
	};
}

class NotSupportedOverlay extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default NotSupportedOverlay;